type PageHeaderProps = {
  title: string;
  subtitle?: string;
  meta?: React.ReactNode;
};

// Sul telefono il titolo lo porta gia' la barra in alto (MobileTopBar): qui
// resta per gli screen reader e si vede solo la riga che spiega la pagina.
export function PageHeader({ title, subtitle, meta }: PageHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-6 mb-[18px] max-md:mb-3 max-md:flex-col max-md:gap-1">
      <div className="max-md:min-w-0">
        <h1 className="font-display text-[30px] font-bold leading-[1.1] tracking-[-0.02em] mb-1 max-md:sr-only">
          {title}
        </h1>
        {subtitle && (
          <p className="text-ink-2 text-[13px] max-md:text-[14px] max-md:leading-snug max-md:text-ink">
            {subtitle}
          </p>
        )}
      </div>
      {meta && (
        <div className="text-right text-ink-3 text-[12px] leading-[1.5] shrink-0 max-md:max-w-full max-md:shrink max-md:overflow-hidden max-md:text-left max-md:text-[13px] max-md:text-ink [&_*]:max-md:whitespace-normal">
          {meta}
        </div>
      )}
    </div>
  );
}
